import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaTicketPage } from './plaza-ticket';

@NgModule({
  declarations: [
    PlazaTicketPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaTicketPage),
    TranslateModule.forChild()
  ],
})
export class PlazaTicketPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-ticket/plaza-ticket.module.ts